/**
 * 16 cryptographically-random bytes. crypto.getRandomValues() is available in
 * ALL contexts (HTTP or HTTPS, any hostname) — unlike crypto.randomUUID(),
 * which browsers restrict to secure contexts (HTTPS or literal "localhost")
 * and throws in plain-HTTP/non-localhost dev or LAN setups.
 */
const randomBytes16 = () => {
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  return bytes;
};

/**
 * Generates a globally-unique, DICOM-valid UI (UID) value client-side, using
 * the standard UUID-derived OID form: "2.25." + the decimal representation of
 * a random 128-bit integer. No central registry/root needed — uniqueness is
 * inherited from the same 128 bits of randomness a UUID is built from.
 *
 * Used to pre-assign the SeriesInstanceUID for a new PR/KO series before saving,
 * so the frontend can later look up that exact series once async DICOM
 * ingestion completes, instead of re-fetching the whole study.
 */
export const generateDicomUID = () => {
  const hex = Array.from(randomBytes16(), (b) => b.toString(16).padStart(2, "0")).join("");
  const decimal = BigInt(`0x${hex}`).toString(10);
  // DICOM UIDs are capped at 64 chars; "2.25." + a 39-digit decimal is 44 — comfortably under.
  return `2.25.${decimal}`;
};
